import * as React from 'react';
import { useState } from 'react';
import classNames from 'classnames';
import pickAttrs from 'rc-util/lib/pickAttrs';
import Overflow from 'rc-overflow';
// import Overflow from '../../../overflow';
import TransBtn from '../TransBtn';
import Input from './Input';
import useLayoutEffect from '../hooks/useLayoutEffect';
import { useLocaleReceiver } from '../../../locale-provider/LocaleReceiver';
const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
};
function itemKey(value) {
    var _a;
    return (_a = value.key) !== null && _a !== void 0 ? _a : value.value;
}
const SelectSelector = props => {
    const { id, prefixCls, values, open, searchValue, inputRef, placeholder, disabled, mode, showSearch, autoFocus, autoComplete, accessibilityIndex, tabIndex, showAllSelectedTag = false, // 输入框中此时是否展示全选的标签
    removeIcon, maxTagCount, maxTagTextLength, maxTagPlaceholder = (omittedValues) => `+ ${omittedValues.length} ...`, tagRender, onToggleOpen, onSelect, onInputChange, onInputPaste, onInputKeyDown, onInputMouseDown, onInputCompositionStart, onInputCompositionEnd, onClearMouseDown } = props;
    const [selectLocale] = useLocaleReceiver('Select');
    const placeholderLocale = placeholder || selectLocale.placeholder;
    const measureRef = React.useRef(null);
    const [inputWidth, setInputWidth] = useState(0);
    const [focused, setFocused] = useState(false);
    const selectionPrefixCls = `${prefixCls}-selection`;
    // ===================== Search ======================
    const inputValue = open || mode === 'tags' ? searchValue : '';
    // const inputEditable: boolean = !showAllSelectedTag && (mode === 'tags' || (showSearch && (open || focused)));
    // 不限制已全选标签下不能搜索
    const inputEditable = mode === 'tags' || (showSearch && (open || focused));
    // We measure width and set to the input immediately
    useLayoutEffect(() => {
        setInputWidth(measureRef.current.scrollWidth);
    }, [inputValue]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    function defaultRenderSelector(content, itemDisabled, closable, onClose, isRest) {
        return (<span className={classNames(`${selectionPrefixCls}-item`, {
                [`${selectionPrefixCls}-item-disabled`]: itemDisabled
            })}>
                <span className={`${selectionPrefixCls}-item-content`} aria-disabled={!closable}>
                    {content}
                </span>
                {isRest ? null : (closable ? (<TransBtn className={`${selectionPrefixCls}-item-remove`} onMouseDown={onPreventMouseDown} onClick={onClose} customizeIcon={removeIcon}>
                            ×
                        </TransBtn>) : (<TransBtn className={`${selectionPrefixCls}-item-remove`} disabled={!closable} customizeIcon={removeIcon}>
                            ×
                        </TransBtn>))}
            </span>);
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
        const onMouseDown = (e) => {
            onPreventMouseDown(e);
            onToggleOpen(true);
        };
        return (<span onMouseDown={onMouseDown}>
                {tagRender({
                label: content,
                value,
                disabled: itemDisabled,
                closable,
                onClose
            })}
            </span>);
    }
    function renderItem({ disabled: itemDisabled, label, value }) {
        const closable = !disabled && !itemDisabled;
        let displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                const strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) {
                    displayLabel = `${strLabel.slice(0, maxTagTextLength)}...`;
                }
            }
        }
        const onClose = (event) => {
            if (event) {
                event.stopPropagation();
            }
            onSelect(value, { selected: false });
        };
        return typeof tagRender === 'function'
            ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose)
            : defaultRenderSelector(displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
        const content = typeof maxTagPlaceholder === 'function'
            ? maxTagPlaceholder(omittedValues)
            : maxTagPlaceholder;
        return defaultRenderSelector(content, false, false, null, true);
    }
    // >>> Input Node
    const inputNode = (<div className={`${selectionPrefixCls}-search`} style={{ width: inputWidth }} onFocus={() => {
            setFocused(true);
        }} onBlur={() => {
            setFocused(false);
        }}>
            <Input ref={inputRef} open={open} prefixCls={prefixCls} id={id} inputElement={null} disabled={disabled} autoFocus={autoFocus} autoComplete={autoComplete} editable={inputEditable} accessibilityIndex={accessibilityIndex} value={inputValue} onKeyDown={onInputKeyDown} onMouseDown={onInputMouseDown} onChange={onInputChange} onPaste={onInputPaste} onCompositionStart={onInputCompositionStart} onCompositionEnd={onInputCompositionEnd} tabIndex={tabIndex} attrs={pickAttrs(props, true)}/>

            {/* Measure Node */}
            <span ref={measureRef} className={`${selectionPrefixCls}-search-mirror`} aria-hidden>
                {inputValue}&nbsp;
            </span>
        </div>);
    // 渲染『全部』tag
    function renderMockAllSelect() {
        const content = selectLocale.checkAll + `（${values.length}）`;
        // 取消全选
        const onClose = (event) => {
            if (event) {
                event.stopPropagation();
            }
            onClearMouseDown === null || onClearMouseDown === void 0 ? void 0 : onClearMouseDown(null);
        };
        return defaultRenderSelector(content, false, true, onClose, false);
    }
    // >>> Selections
    const selectionNode = (<Overflow prefixCls={`${selectionPrefixCls}-overflow`} data={values} renderItem={renderItem} renderRest={renderRest} suffix={inputNode} itemKey={itemKey} maxCount={maxTagCount}/>);
    // 2024-05-07 当showAllSelectedTag为true的时候，造一个『全部』tag样式出来
    const allSelectedNode = (<Overflow prefixCls={`${selectionPrefixCls}-overflow`} data={[{ value: 'mock', key: 'mock' }]} renderItem={renderMockAllSelect} suffix={inputNode} itemKey={itemKey} maxCount={2}/>);
    return (<>
            {!showAllSelectedTag ? selectionNode : allSelectedNode}
            {!values.length && !inputValue && (<span className={`${selectionPrefixCls}-placeholder`}>{placeholderLocale}</span>)}
        </>);
};
export default SelectSelector;
